<template>
  <div class="wrapper">
    <!-- 退费查询结果页 -->
    <div class="mainbox1" style="padding-top: 46px; box-sizing: border-box">
      <!-- <Head v-if="logo" :logo="logo"></Head> -->
      <van-nav-bar
        class="nav"
        title="缴费信息"
        left-arrow
        fixed
        @click-left="btnleft"
      />
      <!-- || fromtype == 5 -->
      <div class="mainContentBox">
        <!-- <div
          class="tab_wraper"
          v-if="
            ((fromtype == 1 && showTabFlag) ) &&
            isSearchHistory != 0 && !isJz
          "
        >
          <div
            class="tab_item"
            @click.prevent="change(index)"
            :class="[active == index ? 'act_tab' : '']"
            v-for="(item, index) in picker"
            :key="index"
          >
            {{ item }}
          </div>
        </div> -->

        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          head-height="120"
          :class="['refreshBox',((fromtype == 1 && showTabFlag) ) &&
            isSearchHistory != 0 && !isJz?'':'reBox',active==1?'rb':'',fromtype==7?'srb':'']"
        >
          <div class="cont">
            <div v-if="dataList.length > 0">
              <List
                :fromType="1"
                :isSelfQ="true"
                @resetAction="afAction = ''"
                :afAction="afAction"
                :checkedAll="checkedAll"
                :dataList="dataList"
                @reget="regetData"
                @handleDetail="showDetail"
                :isMerge="true"
                @checkArr="getCheck"
                :checkedMark="checkedMark"
                @ticketArr="getTicket"
                :showDetailMsg="true"
                @refundAction="refundPayAct"
              ></List>
              <div class="replay" @click="handlePage" v-if="iscode == false">
                <div v-if="dataList.length < total">
                  <div v-if="pageLoading">
                    <van-loading size="24px">加载中...</van-loading>
                  </div>
                  <div v-else><van-icon name="replay" />点击加载更多数据</div>
                </div>
                <div v-else>暂无更多数据</div>
              </div>
            </div>
            <div v-else class="nodata">
              <van-loading
                size="24px"
                v-if="dataList.length == 0 && loading && refreshing == false"
                >加载中...</van-loading
              >
              <div v-if="dataList.length == 0 && !loading">暂无数据</div>
            </div>
          </div>
          <div
            class="btnBox"
            v-if="active == 1 && fromtype == '5' && !isOtherBack  && active !=1 "
          >
            <van-button round block type="info" @click="change(0)" class="btn"
              >继续支付其他应缴费
              <img class="blueSha" src="../../assets/img/blueshadow.png" alt="" />
            </van-button>
          </div>
          <!-- v-else-if="isOtherBack" -->
          <div class="btnBox" v-else-if="isOtherBack">
            <van-button round block type="info" class="btn" @click="goBackRoute"
              >继续支付其他应缴费
              <img class="blueSha" src="../../assets/img/blueshadow.png" alt="" />
            </van-button>
          </div>
          <CustomFoot
            :typeName="'16'"
            :isHome="false"
            class="zdyfooter"
            color="#297bf4"
            state="2"
          >
          </CustomFoot>
          <!-- <Foot
            v-if="list && list.bottomMessage && list.bottomMessage.length > 0"
            :list="list"
          ></Foot> -->
        </van-pull-refresh>
      </div>

      <!-- 选择打印票据的缴款人弹窗 -->
      <van-dialog
        v-model="showSelectModel"
        title="选择开票单位"
        :before-close="beforeClose"
      >
        <div class="paymentSelect">
          <van-radio-group v-model="selectPaymentUnit">
            <van-radio
              v-for="(item, index) in paymentUnitArr"
              :key="index"
              :name="item"
              >{{ item }}</van-radio
            >
          </van-radio-group>
        </div>
      </van-dialog>
      <!-- 查看电子票弹窗 -->
      <!-- <van-dialog v-model="showTicket" title="查看电子票">
        <div class="ticketSelect">
          <van-radio-group v-model="selectTicket" @change="changeTicket">
            <van-radio
              v-for="(item, index) in ticketArr"
              :key="index"
              :name="item"
              >{{ item.dataTypeName }}电子票</van-radio
            >
          </van-radio-group>
        </div>
      </van-dialog> -->
      <div id="widget" />
      <ShowDetailDialog
        :info="selectItem"
        :vde="queryInfo.vde"
        @closeDialog="closeDialog"
        :isShowDetail="isShowDetail"
      ></ShowDetailDialog>

      <BillPhone
        :isShowDialog="isShowBillPhone"
        :isBill="isBill"
        :isShowPhone="isShowPhone"
        :isShowPayNotice="isPayInfo"
        :payPromptInfo="payPromptInfo"
        :isRefNotice="isRefNotice"
        :checkArr="checkArr"
        @payContinue="closeBillPhonePay"
        @closeDialog="isShowBillPhone = false"
      ></BillPhone>

      <RefundReason
      :refundObj="refundObj"
      :isShowDialog="showRefund"
       @payContinue="refundContinue"
        @closeDialog="showRefund = false"
      ></RefundReason>


    </div>
    <div
      class="btnBoxPay"
      v-if="active == 0 && isPay && dataList.length > 0"
    >
      <div class="totalWord">
        <van-checkbox
          shape="square"
          v-model="checkedAll"
          @click="checkPay"
        ></van-checkbox>
        <span class="word">合计(元)：</span>
        <span class="mon">{{ payAmtNotice }}</span>
      </div>
      <van-button
        round
        block
        type="info"
        :disabled="usepay ? false : true"
        @click="beforePay"
        class="btn"
        >支付</van-button
      >
    </div>
    <ErrDialog :show="showErr" :notice="errCon" @close="closeErr"></ErrDialog>
    <van-action-sheet v-model="showTicket">
      <div class="billDetails">
        <h2>选择电子票</h2>
        <div
          class="billDetails_body"
          v-for="(item,index) in ticketArr"
          :key="index"
          :class="[actived == index ? 'billDetails_body_active':'']"
          @click="selectbill(item,index)"
        >
          <h2>{{item.dataTypeName}}电子票</h2>
          <!-- <h2>¥{{item.totalAmt}}</h2> -->
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import Foot from "@/components/foot";
import Head from "@/components/head";
// import List from "@/components/list";
import List from "@/components/refundList";
import ErrDialog from "@/components/dialog/errorNotice";
import { Dialog, Notify, Toast } from "vant";
import { judgeVde } from "@/utils/publicJudge";
import {isUrl, privateDecrypt, savePrivacy} from "@/utils/common";
import DetailDialog from "@/components/detailDialog";
import ItemsDialog from "@/components/itemsDialog";
import BillPhone from "@/components/billPhone";
import RefundReason from "@/components/refundReason";

import ShowDetailDialog from "@/components/showDetailDialog";
import CustomFoot from "@/components/customFoot";

let loadedMineMapJs = false;
export default {
  components: {
    Head,
    List,
    DetailDialog,
    ItemsDialog,
    BillPhone,
    ShowDetailDialog,
    ErrDialog,
    CustomFoot,
    RefundReason
  },
  data() {
    return {
      showRefund:false,
      refundObj:null,
      actived:0,
      afAction: "",
      errCon: "",
      showErr: false,
      checkedAll: false,
      isOtherBack: false, //从家长端或者教育自助支付过来的回调
      queryInfo: {
        confirmType: 1,
        page: 1,
        limit: 50, // 修改限制为50
        vde: "",
        refundSign:'1'
      },
      showmon: "",
      picker: ["未支付", "已支付"],
      isWxmp: false, //判断是否在小程序内
      backQueryData: {
        //小程序回调查询参数
        merchant_order_no: "",
        merchant_no: "",
      },
      active: 0,
      dataList: [],
      list: [], //温馨提示列表
      total: 0,
      isPay: true, //判断是否显示支付按钮
      hasmore: true,
      isSearchHistory: 0, //是否显示已缴费数据
      iscode: false, // 是否通过扫码进入
      checkedMark: "", //选中的数据
      payData: {},
      detailList: [],
      refreshing: false,
      loading: true,
      usepay: true,
      showSelectModel: false,
      paymentUnitArr: [],
      selectPaymentUnit: "", //选择开票单位
      logo: "",
      pageLoading: false,
      showModel: false,
      checkArr: [], //选中的数组
      payAmtNotice: "",
      isPolice: false, //是否为公安入口
      ticketArr: [], //电子票信息
      showTicket: false, //查看电子票列表
      selectTicket: "", //选择的电子票
      ticketInfo: {}, //查看电子票传值
      fromtype: "", //不同类型数据入口 7-教育自助缴费查询缴费入口
      isShowDetail: false,
      dictionaryList: [],
      chInfo: "", //回调

      // 用户指引步数
      stepNum: 1,
      isShowStep: "",
      isBackWithSearch: false,
      phoneInputNum: "",
      remitPayFlag: false,
      // verifyPhoneData:[],
      isPaying: false,

      selectItem: {}, //选中的数据
      isShowDetail: false, //显示详细信息弹窗
      isRefNotice: false,
      isBill: false,
      isShowPhone: false,
      isShowBillPhone: false, //是否展示提示开票信息和手机号码弹窗
      showD: false,
      isPayInfo: false,
      payPromptInfo: "",
      showTabFlag: true,
      isJz :false
    };
  },
  created() {
    this.isWxmp = window.localStorage.getItem("isWxmp") == "1" ? true : false;
    this.initFrom();
    this.initData();

    //判断vde
    judgeVde({ vde: this.queryInfo.vde }, this);
    this.getFootData();
    this.getHeadImg();
  },

  destroyed() {
    Toast.clear();
    sessionStorage.removeItem("isRefresh");
  },
  watch: {
    checkArr: {
      handler(nVal) {
        if (nVal.length > 0) {
          //  == this.dataList.length
          // console.log(1);
          // console.log(nVal.length);
          this.checkedAll = true;
        } else {
          // this.errCon="当前不允许合并支付";

          // console.log(2);
          // console.log(nVal.length);
          this.checkedAll = false;
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
        document.addEventListener("WeixinJSBridgeReady", ready, false);
      } else {
        ready();
      }
      function ready() {
        if (window.__wxjs_environment === "miniprogram") {
          WeixinJSBridge.on("onPageStateChange", function (res) {
            // todo 查询订单支付状态 等逻辑决定是否需要跳转页面
            if (res.active === "true" || res.active === true) {
              window.localStorage.setItem("wxmpBack", "1");
              window.localStorage.setItem("isWxmp", "1");
              let num = new Date().getTime() + Math.floor(Math.random());
              let reslut = window.location.href.indexOf("nowTime");
              if (reslut == -1) {
                window.location.href = window.location.href + "&nowTime=" + num;
              } else {
                let str = window.location.href.slice(0, reslut);
                window.location.href = window.location.href + "&nowTime=" + num;
              }
            }
          });
        }
      }
    }, 0);
    if(localStorage.getItem('jz') != ''&& localStorage.getItem('jz') != null){
      this.isJz = true
    }else{
      this.isJz = false
    }
  },
  methods: {
    refundContinue(item){
      this.showRefund=false;
    },
    refundPayAct(item){
      this.showRefund=true;
      this.refundObj=item;
    },
    selectbill(item, index) {
      this.actived = index
      // this.showTicket(item.merchantOrderNo)
      this.changeTicket(item);
    },
    btnleft() {
      this.$router.push({
        path:'/refundQuery',
        query:{
          vde:localStorage.getItem("vde"),
        }
      });
      // if (localStorage.getItem("payRouteBack")) {
      //   let routName = JSON.parse(
      //     localStorage.getItem("payRouteBack")
      //   ).routeName;
      //   if (routName == "selfEduPrePayList") {
      //     //教育自助支付
      //     this.$router.push({
      //       name: routName,
      //       query: {
      //         deptId: JSON.parse(localStorage.getItem("payRouteBack")).deptId,
      //         uId: JSON.parse(localStorage.getItem("payRouteBack")).uId,
      //         vde: JSON.parse(localStorage.getItem("payRouteBack")).vde,
      //         name: JSON.parse(localStorage.getItem("payRouteBack")).name,
      //         idCard: JSON.parse(localStorage.getItem("payRouteBack")).idCard,
      //       },
      //       params: {
      //         out: JSON.parse(localStorage.getItem("payRouteBack")).out,
      //       },
      //     });
      //   }
      //   localStorage.removeItem("payRouteBack");
      //   localStorage.removeItem("fromEdu");
      // } else {
      //   localStorage.removeItem("payRouteBack");
      //   localStorage.removeItem("fromEdu");
      //   this.$router.go(-1);
      // }
    },
    closeErr() {
      this.showErr = false;
    },
    // 选择全部进行支付
    checkPay() {
      if (this.checkedAll) {
        this.afAction = "1";
      } else {
        this.afAction = "2";
        this.dataList.forEach((item) => {
          this.$set(item, "checked", false);
        });
        this.checkArr = [];
        this.getCheck(this.checkArr);
      }
    },
    isWx() {
      return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1; //通用
    },
    closeO() {
      this.showD = false;
    },
    // 存储隐私授权接口
    savePrivacy() {
      if (sessionStorage.getItem("privacyDetailsH5")) {
        if (this.dataList.length > 0) {
          let row = this.dataList[0];
          let data = {
            details: JSON.parse(sessionStorage.getItem("privacyDetailsH5")),
            userId: row.paymentUnit,
            userName: row.idCard
              ? row.idCard
              : row.phone
              ? row.phone
              : row.paymentUnit,
          };
          savePrivacy(data);
          sessionStorage.removeItem("privacyDetailsH5");
        }
      }
    },
    regetData() {
      // window.location.reload();
      if (
        (this.fromtype == 1 || this.fromtype == 5) &&
        this.isSearchHistory != 0
      ) {
        this.change(this.active);
      } else {
        window.location.reload();
      }
    },
    // 初始化来源，判断是否在微信小程序内
    initFrom() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            this.isWxmp = true;
          } else {
          }
        });
      } else {
      }
    },
    // 初始化数据
    initData() {
      if (this.$route.query.s) {
        //加密
        this.queryInfo.vde = this.$route.query.vde ? this.$route.query.vde : "";
        let queryInfo = JSON.parse(privateDecrypt(this.$route.query.s));
        this.fromtype = JSON.parse(JSON.stringify(queryInfo.fromtype));
        if (queryInfo.isWxNotice == "1") {
          //公众号嵌入页面
          localStorage.setItem("searchInfo", JSON.stringify(queryInfo));
        }
        delete queryInfo.fromtype;
        Object.keys(queryInfo).forEach((key) => {
          this.$set(this.queryInfo, key, queryInfo[key]);
        });
        // this.queryInfo.type
        this.queryInfo.confirmType = '1';
        this.queryInfo.refundSign='1';
      } else {
        //不加密
        this.queryInfo = JSON.parse(JSON.stringify(this.$route.query));
        this.fromtype = this.queryInfo.fromtype;
        if (this.queryInfo.type) {
          this.queryInfo.confirmType = JSON.parse(
            JSON.stringify(this.queryInfo.type)
          );
          delete this.queryInfo.type;
        }
        delete this.queryInfo.fromtype;
        this.queryInfo.confirmType='1';
        this.queryInfo.refundSign='1';
      }
      localStorage.setItem("RouteQuery", JSON.stringify(this.$route.query));
      if (window.localStorage.getItem("fromEdu")) {
        this.showTabFlag = false;
      }
      // if (this.queryInfo.mon) {
      //   //回调
      //   this.queryInfo.confirmType = 1;
      //   this.active = 1;
      //   this.showmon = this.queryInfo.mon;
      //   this.picker = ["未支付", "已支付"];
      // }
      if (this.fromtype == 1) {
        // this.queryInfo.confirmType = 0;
        if (this.isWxmp) {
          //清除查缴存放的缓存
          window.localStorage.removeItem("searchInfo");
          if(!window.localStorage.getItem("fromEdu")){
            // 清除掉教育自助缴费的回调缓存
            window.localStorage.removeItem("payRouteBack");
          }
          // 小程序支付成功的回调
          if (window.localStorage.getItem("wxmpBack") == "1") {
            this.backQueryData.merchant_order_no =
              window.localStorage.getItem("merchant_order_no");
            this.backQueryData.merchant_no =
              window.localStorage.getItem("merchant_no");
            this.getBackData();
          } else {
            this.getData(); //查询进入
          }
        } else {
          // 清除掉教育自助缴费的payRouteBack缓存
          if(!window.localStorage.getItem("fromEdu")){
            // 清除掉教育自助缴费的回调缓存
            window.localStorage.removeItem("payRouteBack");
          }
          this.getData(); //查询进入
        }
      }

      // if (this.fromtype == 2) {
      //   //清除查缴存放的缓存
      //   window.localStorage.removeItem("searchInfo");
      //   if(!window.localStorage.getItem("fromEdu")){
      //       // 清除掉教育自助缴费的回调缓存
      //       window.localStorage.removeItem("payRouteBack");
      //     }
      //   localStorage.removeItem("fromEdu");

      //   this.checkedMark = this.queryInfo.bizId;
      //   this.getQueryData(); //扫码进入
      // }
      // if (this.fromtype == 3) {
      //   //清除查缴存放的缓存
      //   window.localStorage.removeItem("searchInfo");
      //   if(!window.localStorage.getItem("fromEdu")){
      //     // 清除掉教育自助缴费的回调缓存
      //     window.localStorage.removeItem("payRouteBack");
      //   }
      //   localStorage.removeItem("fromEdu");

      //   this.checkedMark = this.queryInfo.bizId;
      //   this.getNoticeQuery(); //扫码进入
      // }
      // // 公安入口  合并2.0，列表可多选
      // if (this.fromtype == 6) {
      //   //清除查缴存放的缓存
      //   window.localStorage.removeItem("searchInfo");
      //   if(!window.localStorage.getItem("fromEdu")){
      //       // 清除掉教育自助缴费的回调缓存
      //       window.localStorage.removeItem("payRouteBack");
      //     }
      //   localStorage.removeItem("fromEdu");
      //   this.isPolice = true;
      //   this.getFromTypeFourData();
      // }

      // if (this.fromtype == 7) {
      //   this.getSelfData();
      //   this.initBack();
      // }

      // // 回调链接
      // if (this.fromtype == 5) {
      //   this.chInfo = this.$route.query.chInfo ? this.$route.query.chInfo : "";
      //   this.active = this.queryInfo.confirmType;
      //   Toast.loading({
      //     message: "加载中...",
      //     forbidClick: true,
      //     duration: 0,
      //   });
      //   setTimeout(() => {
      //     this.getFromTypeFiveData(1);
      //   }, 1500);
      //   this.initBack();
      // }
    },
    // 支付回调处理,payRouteBack记录了上个页面的数据信息
    initBack() {
      if (localStorage.getItem("payRouteBack")) {
        //存了数据
        this.isOtherBack = true;
      }
    },
    // 点击返回上次查询页面
    goBackRoute() {
      let routName = JSON.parse(localStorage.getItem("payRouteBack")).routeName;
      if (routName == "selfEduPrePayList") {
        //教育自助支付
        this.$router.push({
          name: routName,
          query: {
            deptId: JSON.parse(localStorage.getItem("payRouteBack")).deptId,
            uId: JSON.parse(localStorage.getItem("payRouteBack")).uId,
            vde: JSON.parse(localStorage.getItem("payRouteBack")).vde,
            name: JSON.parse(localStorage.getItem("payRouteBack")).name,
            idCard: JSON.parse(localStorage.getItem("payRouteBack")).idCard,
          },
          params: {
            out: JSON.parse(localStorage.getItem("payRouteBack")).out,
          },
        });
      }
      localStorage.removeItem("payRouteBack");
      localStorage.removeItem("fromEdu");
    },
    // 初始化新手指引
    initIsFirst() {
      if (
        this.active == 0 &&
        this.dataList.length > 0 &&
        (this.fromtype == 1 || this.fromtype == 5) &&
        this.stepNum == 1
      ) {
        this.isShowStep =
          localStorage.getItem("isShowStep") == "1" ? false : true;
      }
    },
    closeStep() {
      localStorage.setItem("isShowStep", "1");
      this.isShowStep =
        localStorage.getItem("isShowStep") == "1" ? false : true;
    },
    // 子传父的参数（用于弹窗）
    //  handleItem(data) {
    //     this.showModel = true;
    //     this.detailList = data;
    // },
    showDetail(item) {
      this.selectItem = item;
      this.request({
        url: "/mobile/queryDataItem",
        method: "get",
        params: {
          uId: item.uId,
          sysType: item.sysType,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          let data = res.data.result;
          let showFieldList = data.showFieldList;
          this.selectItem = JSON.parse(JSON.stringify(item));
          let arr =
            showFieldList &&
            showFieldList.filter(item => {
              return item.fieldName.indexOf("kz") == 0;
            });
          arr &&
            arr.map(it => {
              item[it.fieldName] = res.data?.result[it.fieldName];
            });
          showFieldList &&
            showFieldList.map(it => {
                this.selectItem[it.fieldName] = data[it.fieldName];
            });
          this.selectItem.items = res.data.result.items;
          this.selectItem.showFieldList = res.data?.result?.showFieldList;
          this.isShowDetail = true;
        }
      });
      // this.isShowDetail = true;
    },
    closeDialog() {
      this.selectItem = {};
      this.isShowDetail = false;
    },
    // 下拉刷新
    async onRefresh() {
      this.queryInfo.page = 1;
      this.queryInfo.limit = 50;
      this.dataList = [];
      this.loading = true;

      if (this.fromtype == 1) {
        await this.getData();
      }
      // if (this.fromtype == 2) {
      //   await this.getQueryData();
      // }
      // if (this.fromtype == 3) {
      //   await this.getNoticeQuery();
      // }
      // if (this.fromtype == 6) {
      //   await this.getFromTypeFourData();
      // }
      // if (this.fromtype == 5) {
      //   if (this.active == 0 && this.isBackWithSearch) {
      //     await this.getData();
      //   } else {
      //     await this.getFromTypeFiveData();
      //   }
      // }
      // // 教育自助缴费
      // if (this.fromtype == 7) {
      //   await this.getSelfData();
      // }
      this.hasmore = true;
      this.refreshing = false;
      await Toast("刷新成功");
    },

    // 切换导航栏
    change(e) {
      if (this.loading || this.pageLoading) {
        // Dialog.alert({
        //   title: "提示",
        //   message: "还有数据正在加载，请稍后切换导航...",
        // }).then(() => {
        // });
        // this.showErr = true;
        // this.errCon = "还有数据正在加载，请稍后切换导航...";
        this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '还有数据正在加载，请稍后切换导航...'
              });
        this.active = e == 1 ? 0 : 1;

        return;
      }
      if (this.active != e) {
        this.active = e;
        this.dataList = [];
        this.queryInfo.page = 1;
        this.queryInfo.limit = 50;
        if (e == 0) {
          if (this.fromtype == 5 && window.localStorage.getItem("searchInfo")) {
            this.isBackWithSearch = true;
            var searchInfo = localStorage.getItem("searchInfo")
              ? JSON.parse(localStorage.getItem("searchInfo"))
              : {};
            this.queryInfo = Object.assign(this.queryInfo, searchInfo);
            delete this.queryInfo.fromtype;
          }
          this.queryInfo.confirmType = 0;
          this.queryInfo.mon = "";
        } else if (e == 1) {
          this.queryInfo.confirmType = 1;
          if (this.showmon && this.isSearchHistory == 1) {
            this.queryInfo.mon = "";
          } else if (this.showmon && this.isSearchHistory == 0) {
            this.queryInfo.mon = this.showmon;
          }
        }
        this.hasmore = true;
        if (this.fromtype == 1) {
          this.getData();
        } else if (this.fromtype == 5) {
          if (e == 0 && this.isBackWithSearch) {
            this.getData();
          } else {
            this.getFromTypeFiveData();
          }
        }
      }
    },
    // 获取头像
    getHeadImg() {
      this.request({
        url: "/webPortal/websitConfig",
        method: "get",
        params: { vde: this.queryInfo.vde },
      }).then((res) => {
        if (res.data.code == 1000) {
          if (res.data.result.logoUrlLogin) {
            this.logo = res.data.result.logoUrlLogin;
          } else {
            this.logo = require("@/assets/img/logo.png");
          }
          sessionStorage.setItem("title", res.data.result.websitTitle);
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" });
        }
      });
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.queryInfo.vde,
        type: 16,
      };
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code != 1000) {
        } else {
          this.list = res.data.result;
          if (this.iscode == false) {
            this.isSearchHistory = res.data.result.isSearchHistory;
          }
        }
      });
    },
    // 分页
    handlePage() {
      if (this.dataList.length < this.total) {
        this.pageLoading = true;
        this.queryInfo.page++;
        this.getData();
      } else {
      }
    },
    // 从查询页进来的
    getData() {
      if (this.queryInfo.page == 1) {
        // this.dataList = [];
        this.loading = true;
      } else {
        this.pageLoading = true;
      }
      console.log(this.queryInfo)
      return new Promise((resolve) => {
        this.request({
          url: "/mobile/queryData",
          method: "get",
          params: this.queryInfo,
        }).then((res) => {
          if (res.data.code == 1000) {
            if (res.data.result != null) {
              if (this.queryInfo.page == 1) {
                this.dataList = res.data.result.list;
              } else {
                this.dataList = this.dataList.concat(res.data.result.list);
              }
              // this.dataList[1].billInterfaceType = 2
              this.total = res.data.result.total;
              this.isPay = this.dataList.some((val) => {
                return val.isConfirm != 1;
              });
              this.savePrivacy();
              let isWx = this.isWx();
              if (this.dataList.length > 0 && isWx) {
                this.getBindQuery(false);
              } else if (this.dataList.length > 0 && this.isWxmp) {
                this.getBindQuery(true);
              }
            }
            this.$forceUpdate();
            this.initIsFirst();
          } else {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            // this.showErr = true;
            // this.errCon = res.data.message;
            let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
          }
          this.loading = false;
          this.pageLoading = false;
          resolve();
        });
      });
    },
    getBindQuery(flag) {
      let openId = "";
      let appid = "";
      if (localStorage.getItem(this.queryInfo.vde + "opendID")) {
        openId = localStorage.getItem(this.queryInfo.vde + "opendID");
      }
      if (localStorage.getItem("appId")) {
        appid = localStorage.getItem("appId");
      }

      this.request({
        url: "/mobile/queryWxBind",
        method: "get",
        params: {
          confirmType: this.queryInfo.confirmType,
          idCard: this.queryInfo.idCard ? this.queryInfo.idCard : "",
          phone: this.queryInfo.phone ? this.queryInfo.phone : "",
          paymentUnit: this.queryInfo.paymentUnit
            ? this.queryInfo.paymentUnit
            : "",
          type: "1",
          vde: this.queryInfo.vde ? this.queryInfo.vde : "",
          userId: flag && this.queryInfo.userId ? this.queryInfo.userId : "",
          openid: openId,
          appId: appid,
          wxOpenId: openId,
          mon: this.queryInfo.mon ? this.queryInfo.mon : "",
          remark: this.queryInfo.remark ? this.queryInfo.remark : "",
          confirmType: this.queryInfo.confirmType,
        },
      }).then((res) => {
        if (res.data.code == 1000) {
          // Toast({ message: res.data.message, icon: "none" });
        } else {
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {});
          // this.showErr = true;
          // this.errCon = res.data.message;
          let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
        }
      });
    },
    // 扫码进入的
    getQueryData() {
      this.iscode = true;
      this.request({
        url: "/mobile/qrcodeQueryData",
        method: "get",
        params: this.queryInfo,
      }).then((res) => {
        this.loading = false;
        if (res.data.code == 1000) {
          this.dataList = res.data.result;
          this.isPay = this.dataList.some((val) => {
            return val.isConfirm != 1;
          });
          if (this.dataList.length == 1) {
            this.checkedMark = this.queryInfo.bizId;
          }
        } else {
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {});
          // this.showErr = true;
          // this.errCon = res.data.message;
          let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
        }
      });
    },
    //告知单扫描进入
    getNoticeQuery() {
      this.iscode = true;
      this.request({
        url: "/mobile/queryData",
        method: "get",
        params: this.queryInfo,
      }).then((res) => {
        this.loading = false;
        this.pageLoading = false;
        if (res.data.code == 1000) {
          if (res.data.result != null) {
            this.dataList = this.dataList.concat(res.data.result.list);
            this.total = res.data.result.total;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
          }
          this.$forceUpdate();
        } else {
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {});
          // this.showErr = true;
          // this.errCon = res.data.message;
          let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
        }
      });
    },
    // formtype=6
    getFromTypeFourData() {
      this.request({
        url: "/mobile/queryPoliceData",
        method: "get",
        params: this.queryInfo,
      }).then((res) => {
        this.loading = false;
        this.pageLoading = false;
        if (res.data.code == 1000) {
          if (res.data.result != null) {
            this.dataList = this.dataList.concat(res.data.result.list);
            this.total = res.data.result.total;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
          }
          this.$forceUpdate();
        } else {
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {});
          // this.showErr = true;
          // this.errCon = res.data.message;
          let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
        }
      });
    },
    // formtype=5
    getFromTypeFiveData(type) {
      this.request({
        url: "/mobile/queryDataByMerOrderNo?time=" + new Date().getTime(),
        method: "get",
        params: this.queryInfo,
      }).then((res) => {
        Toast.clear();
        this.loading = false;
        this.pageLoading = false;
        if (res.data.code == 1000) {
          if (res.data.result != null) {
            this.nowTime = new Date().getTime();
            if (this.queryInfo.page == 1) {
              this.dataList = res.data.result.list;
            } else {
              this.dataList = this.dataList.concat(res.data.result.list);
            }
            this.total = res.data.result.total;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
            this.initBack();
            this.$forceUpdate();
          } else {
            if (type == "1") {
              this.queryInfo.page = 1;
              setTimeout((val) => {
                this.getFromTypeFiveData();
              }, 500);
            }
          }
        } else {
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {});
          // this.showErr = true;
          // this.errCon = res.data.message;
          let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
        }
      });
    },
    // 教育自助缴费 fromtype==7 获取数据
    getSelfData() {
      return new Promise((resolve) => {
        this.request({
          url: "/mobile/listPayPrepaid",
          method: "post",
          params: this.queryInfo,
        }).then((res) => {
          this.loading = false;
          this.refreshing = false;
          if (res.data.code == 1000) {
            if (res.data.result != null) {
              this.dataList = res.data.result.list;
              this.total = res.data.result.total;
              let findItem = this.dataList.find((item) => {
                if (item.isConfirm != "1") {
                  return item;
                }
              });
              if (findItem) {
                this.checkedMark = findItem.uId;
              }
              this.isPay = this.dataList.some((val) => {
                return val.isConfirm != 1;
              });
            }
          } else {
            // Dialog.alert({
            //   title: "提示",
            //   message: res.data.message,
            // }).then(() => {});
            // this.showErr = true;
            // this.errCon = res.data.message;
            let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
          }
          resolve();
        });
      });
    },
    beforeClose(action, done, data) {
      if (this.selectPaymentUnit == "") {
        Notify("请选择需要开票的单位");
        done(false);
      } else {
        this.payData.payerName = this.selectPaymentUnit;
        this.sourcePay();
        done();
      }
    },
    getCheck(checkArr) {
      this.checkArr = checkArr;
      let amt = 0;
      this.checkArr.forEach((item) => {
        amt = amt + Number(item.paymentTotal);
      });
      this.payAmtNotice = "¥ " + amt.toFixed(2);
    },
    // 子组件传过来的电子票信息
    getTicket(ticketArr, data) {
      this.ticketInfo = data;
      if (ticketArr.length == 1) {
        this.changeTicket(ticketArr[0]);
      } else if (ticketArr.length > 1) {
        // 多条电子票，展示弹框
        this.ticketArr = ticketArr;
        this.showTicket = true;
        this.selectTicket = "";
      }
    },
    //点击电子票
    changeTicket(e) {

      var device = navigator.userAgent;
      var isiOS = !!device.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (e.einvoiceUrl) {
        let prefix = e.einvoiceUrl.slice(0, 5);
        this.showTicket=false;
        if (prefix === "https") {
          this.$router.push({
            path: "/eTicket?url=" + encodeURIComponent(e.einvoiceUrl),
          });
        } else if (prefix != "https") {
          window.location.href = e.einvoiceUrl;
        }
        // else{  &&isiOS
        //   this.$router.push({
        //     path: "/eTicket?url=" + encodeURIComponent(e.einvoiceUrl),
        //   });
        // }

        // this.$router.push({
        //   path: "/eTicket?url=" + encodeURIComponent(e.einvoiceUrl),
        // });
      } else {
        this.showTicket=false;
        this.ticketInfo.dataType = e.dataType;
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });

        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url: "/pay/showETicket",
          method: "post",
          data: this.ticketInfo,
        }).then((res) => {
          if (res.data.code == 1000) {
            // let prefix = res.data.message.slice(0, 5);
            // if (prefix === "https") {
            //   this.$router.push({
            //     path: "/eTicket?url=" + encodeURIComponent(res.data.message),
            //   });
            // } else if (prefix != "https") {
            //   // &&isiOS
            //   window.location.href = res.data.message;
            // }
            let result = isUrl(res.data.message);
            if (result !== null) {
              let prefix = res.data.message.slice(0, 5);
              if (prefix === 'https') {
                this.$router.push({
                  path: '/eTicket?url=' + encodeURIComponent(res.data.message),
                });
              } else if (prefix != 'https' && isiOS) {
                window.location.href = res.data.message;
              } else {
                this.$router.push({
                  path: '/eTicket?url=' + encodeURIComponent(res.data.message),
                });
              }
            } else {
              this.$store.commit('notice/setPicture', res.data.message);
              this.$router.push({
                path:'/eTicketPicture'
              })
            }
          } else {
            Toast(res.data.message);
          }
        });
      }
    },

    // type-27开票 type-28手机号码
    initPayType(payData) {
      let info = [
        { type: "27", value: "isBill" },
        { type: "28", value: "isShowPhone" },
      ];
      let arr = [];
      // console.log(this.checkArr);
      let dataTypeArr = [];
      this.checkArr.forEach((item) => {
        let flag = dataTypeArr.some((it) => {
          return it == item.dataType;
        });
        if (!flag) {
          dataTypeArr.push(item.dataType);
        }
      });
      // console.log(dataTypes);
      // info.forEach((item)=>{
      arr.push(
        new Promise((resolve, reject) => {
          this.request({
            baseURL: process.env.VUE_APP_PAY_URL,
            url: "/public/pay_prompt",
            method: "post",
            data: {
              deptId: payData.deptId,
              phoneFunType: "28",
              billFunType: "27",
              dataTypes: dataTypeArr,
            },
          }).then((res) => {
            if (res.data.code == 1000) {
              // this[item.value] = res.data.result.value;
              // console.log(res);
              // 退付记录开关
              // this.isRefNotice=res.data.result.accountPrompt;

              this.isBill = res.data.result.billPrompt;
              this.isShowPhone = res.data.result.phonePrompt;
              this.isPayInfo = res.data.result.payPrompt;
              if (this.isPayInfo) {
                this.payPromptInfo = res.data.result.payPromptInfo;
              }
              resolve();
            } else {
              // Dialog.alert({
              //   title: "提示",
              //   message: res.data.message,
              // }).then(() => {});
              // this.showErr = true;
              // this.errCon = res.data.message;
              let str = "确认";
            if (res.data.errorMessage) {
              str = "查看错误详情";
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              }).then(() => {
                this.$CTips({
                  title: "错误提示",
                  message: res.data.errorMessage,
                  clickOverlay: false
                });
              });
            } else {
              this.$CDialog({
                confirmBtnText: str,
                title: "提示",
                status: "2",
                message: res.data.message
              });
            }
              reject();
            }
          });
        })
      );
      // })

      // &&this.isRefNotice==false
      Promise.all(arr).then((res) => {
        if (
          this.isBill == false &&
          this.isShowPhone == false &&
          this.isPayInfo == false
        ) {
          this.handlePay(); //走原流程支付
        } else {
          // 弹窗弹出信息
          if (this.isShowPhone) {
            this.verifyPhone();
          } else {
            this.isShowBillPhone = true;
          }
        }
      });
    },
    //支付前的操作
    beforePay() {
      let bool = this.dataList.some((val) => {
        return val.checked;
      });
      //是否为汇缴合并支付
      let checkLen = this.checkArr.length;
      this.remitPayFlag = false;
      this.isPaying = false;
      if (checkLen > 1) {
        this.remitPayFlag = this.checkArr.some((val) => {
          return (
            val.merchantType == "001" ||
            val.merchantType == "002" ||
            val.merchantType == "003" ||
            val.merchantType == "004" ||
            val.merchantType == '015' ||
            val.merchantType == '016'||
            val.merchantType == '017'
          );
        });
      } else if (checkLen == 1) {
        if (
          this.checkArr[0].merchantType == "001" ||
          this.checkArr[0].merchantType == "002" ||
          this.checkArr[0].merchantType == "003" ||
          this.checkArr[0].merchantType == "004" ||
          this.checkArr[0].merchantType == '015' ||
          this.checkArr[0].merchantType == '016' ||
          this.checkArr[0].merchantType == '017'
        ) {
          this.remitPayFlag = true;
        }
      }
      if (bool) {
        // console.log(this.checkArr[0])
        this.initPayType(this.checkArr[0]); //获取该单位是否配置了开票信息
        // /public/pay_prompt
      } else {
        // Dialog.alert({
        //   title: "提示",
        //   message: "请选择需要缴费的项目",
        // }).then(() => {});
        // this.showErr = true;
        // this.errCon = "请选择需要缴费的项目";

              this.$CDialog({
                confirmBtnText: '确认',
                title: "提示",
                status: "2",
                message: '请选择需要缴费的项目'
              });

      }
    },
    //接口校验单位是否配置手机号字段
    verifyPhone() {
      let info = [];
      this.checkArr.forEach((item) => {
        let obj = {
          uId: item.uId,
          sysType: item.sysType,
          phone: item.phone,
          payerType: item.payerType,
          deptId: item.deptId || this.queryInfo.vde,
        };
        info.push(obj);
      });
      this.request({
        url: "/payPhoneInput/verifyPhoneInput",
        method: "post",
        data: info,
      }).then((res) => {
        if (res.data.code == 1000) {
          //输入手机号
          this.isShowBillPhone = true;
        } else {
          this.handlePay();
        }
      });
    },
    closeBillPhonePay() {
      //  录入手机号码和缴款人类型后，继续调支付
      this.isShowBillPhone = false;
      this.handlePay();
    },
    handlePay() {
      let bizDatas = [];
      let payAmt = 0;
      let billInterfaceType = "";
      this.usepay = false;
      this.checkArr.forEach((val) => {
        let arr = {
          bizId: val.uId,
          sysType: val.sysType,
        };
        if (this.remitPayFlag) {
          arr.deptId = val.deptId;
        }
        bizDatas.push(arr);
        payAmt += Number(val.paymentTotal);
        if (val.paymentUnit && val.extraPaymentUnit) {
          this.paymentUnitArr = [val.paymentUnit, val.extraPaymentUnit];
          this.showSelectModel = true;
        }
        billInterfaceType = val.billInterfaceType;
        // 判断是否存在支付中的数据
        if (val.isConfirm == "9") {
          this.isPaying = true;
        }
      });
      this.payData = {
        bizDatas: bizDatas,
        payAmt: payAmt.toFixed(2),
        deviceType: "phone",
        billInterfaceType: billInterfaceType,
        isPolice: this.isPolice,
      };
      // 微信小程序参数
      if (this.isWxmp) {
        this.payData.deviceType = "miniProgramH5";
        this.$set(this.payData, "userId", this.queryInfo.userId);
        this.$set(this.payData, "openid", this.queryInfo.openid);
        this.$set(this.payData, "paymentName", this.queryInfo.paymentName);
      }
      if (this.showSelectModel == false) {
        this.sourcePay();
      }
    },
    sourcePay() {
      if (this.remitPayFlag) {
        //是汇缴合并支付
        this.remitPay(this.payData);
      } else {
        //否汇缴合并支付
        this.pay(this.payData);
      }
    },

    pay(data) {
      if (this.isPaying) {
        this.$CDialog({
          confirmBtnText: "是",  //按钮文字
          title: "提示",    //title提示文字
          message: "选中的数据存在支付中数据，是否继续支付？",   //弹窗内容
          status: "2", //显示哪种图   1 为绿色   2为蓝色
          textSize:'16', // 字体大小，默认12
          cancelBtnText:'否'
        }).then((res) => {
          this.payRquuest(data);
          //点击确定之后的处理
        }).catch((rs) => {
          this.usepay = true;
        })
        // Dialog.confirm({
        //   title: "提示",
        //   message: "选中的数据存在支付中数据，是否继续支付？",
        //   confirmButtonText: "是",
        //   cancelButtonText: "否",
        // })
        //   .then(() => {
        //     this.payRquuest(data);
        //   })
        //   .catch(() => {
        //     this.usepay = true;
        //   });
      } else {
        this.payRquuest(data);
      }
    },
    payRquuest(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/epay/pay_init",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {
            this.usepay = true;
          });
          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {
          //   this.usepay = true;
          // window.location.reload();
          // });
        }
      });
    },
    remitPay(data) {
      if (this.isPaying) {
        this.$CDialog({
          confirmBtnText: "是",  //按钮文字
          title: "提示",    //title提示文字
          message: "选中的数据存在支付中数据，是否继续支付？",   //弹窗内容
          status: "2", //显示哪种图   1 为绿色   2为蓝色
          textSize:'16', // 字体大小，默认12
          cancelBtnText:'否'
        }).then((res) => {
          this.remitPayRequest(data);
          //点击确定之后的处理
        }).catch((rs) => {
          this.usepay = true;
        })
        // Dialog.confirm({
        //   title: "提示",
        //   message: "选中的数据存在支付中数据，是否继续支付？",
        //   confirmButtonText: "是",
        //   cancelButtonText: "否",
        // })
        //   .then(() => {
        //     this.remitPayRequest(data);
        //   })
        //   .catch(() => {
        //     this.usepay = true;
        //   });
      } else {
        this.remitPayRequest(data);
      }
    },
    remitPayRequest(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/merger/remit_pay",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: res.data.message,
          }).then((res) => {
            this.usepay = true;
            window.location.reload();
          });

          // Dialog.alert({
          //   title: "提示",
          //   message: res.data.message,
          // }).then(() => {
          //   this.usepay = true;
          //   window.location.reload();
          // });
        }
      });
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      // 微信小程序中，多加几个参数
      if (this.isWxmp) {
        this.$set(obj, "paymentName", res.paymentName);
        this.$set(obj, "itemNameSet", res.itemNameSet);
        this.$set(obj, "userId", res.userId);
      }
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
          that.usepay = true;
        }
      }, 100);
    },
    // 小程序支付成功后回调
    getBackData() {
      this.picker = ["未支付", "已支付"];
      this.active = 1;
      this.queryInfo.confirmType = 1;
      this.queryInfo.page = 1;
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url: "/epay/order_query",
        method: "post",
        data: this.backQueryData,
      }).then((res) => {
        this.loading = false;
        if (res.data.code == 1000) {
          this.queryInfo.mon = res.data.result.merchant_order_no;
          window.localStorage.setItem("wxmpBack", "");
          window.localStorage.setItem("merchant_order_no", "");
          window.localStorage.setItem("merchant_no", "");
          this.getData();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.zdyfooter{
  margin-top: 30px !important;
}
.mainbox1 {
  background: #fff;
  ::v-deep .van-loading__text {
    color: #fff !important;
  }
  ::v-deep .van-pulling__text {
    color: #fff !important;
  }
  ::v-deep .van-pull-refresh__head {
    color: #fff !important;
  }
  ::v-deep .van-loosing__text {
    color: #fff !important;
  }
  ::v-deep .van-nav-bar {
    background: transparent !important;
  }
  ::v-deep .van-hairline--bottom::after {
    border: none !important;
  }
  ::v-deep .van-nav-bar__title {
    color: #fff;
  }
  ::v-deep .van-icon-arrow-left {
    color: #fff;
  }
  padding: 0 15px;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  background: url("../../assets/img/queryBW.png") no-repeat;
  background-size: 100% 100%;
  min-height: 100vh;
  ::v-deep .van-tabs__nav {
    background-color: transparent;
    opacity: 1;

    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
  }
  ::v-deep .van-tab {
    color: rgba(255, 255, 255, 0.8);
  }
  ::v-deep .van-tab--active {

    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: right;
    font-weight: 500;
    .van-tab__text {
      opacity: 1;
    }
  }
  ::v-deep .van-tabs__line {
    background-color: #fff !important;
  }
  .modelBox {
    width: 100vw;
    height: 100vh;
    background: #000;
    opacity: 0.4;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
  }
  .mainContentBox {
    position: relative;
    .tab_wraper {
      margin-top: 6px;
      width: 345px;
      height: 44px;
      margin-bottom: 8px;
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      .tab_item {
        opacity: 0.8;

        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
        // padding-left: 30px;
        box-sizing: border-box;
      }
      .tab_item.act_tab {
        opacity: 1;

        font-size: 20px;
        color: #208fff;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
      .tab_item:nth-of-type(1) {
        text-align: center;
        line-height: 40px;
        width: 189px;
        height: 40px;
        background: url("../../assets/img/notpayTab.png") no-repeat;
        background-size: 100% 100%;
        padding-right: 25px;
        box-sizing: border-box;
      }

      .tab_item:nth-of-type(2) {
        text-align: center;
        line-height: 40px;
        width: 189px;
        height: 40px;
        background: url("../../assets/img/paidTab.png") no-repeat;
        background-size: 100% 100%;
        padding-left: 30px;
        box-sizing: border-box;
      }
      .tab_item:nth-of-type(1).act_tab {
        text-align: left;
        line-height: 44px;
        padding-left: 56px;
        box-sizing: border-box;
        width: 199px;
        height: 44px;
        background: url("../../assets/img/actTab.png") no-repeat;
        background-size: 100% 100%;
        margin-right: -43px;
      }
      .tab_item:nth-of-type(2).act_tab {
        text-align: right;
        line-height: 44px;
        padding-right: 56px;
        box-sizing: border-box;
        width: 199px;
        height: 44px;
        background: url("../../assets/img/actPayTab.png") no-repeat;
        background-size: 100% 100%;
        margin-left: -43px;
      }
    }
    .step1Img {
      position: absolute;
      width: 300px;
      z-index: 101;
      left: 0;
      top: -55px;
    }
    .step4Img {
      position: absolute;
      width: 250px;
      z-index: 101;
      left: 120px;
      top: -65px;
    }
    .step6Img {
      position: absolute;
      width: 250px;
      z-index: 101;
      left: 110px;
      top: -10px;
    }
    .step2Img {
      position: absolute;
      width: 300px;
      z-index: 101;
      left: 70px;
      top: 170px;
    }
    .step5Img {
      position: absolute;
      width: 200px;
      z-index: 101;
      left: 90px;
      top: 210px;
    }
  }
  .btnBox {
    position: relative;
    .step3Img {
      position: absolute;
      width: 380px;
      z-index: 101;
      left: -6px;
      top: -110px;
    }
    > .btn {
      background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);

      border: none;
      outline: none;
      font-size: 18px;
      .blueSha {
        width: 324px;
        height: 34px;
        position: absolute;
        left: 50%;
        top: 68%;
        transform: translateX(-50%);
      }
    }
  }
}

.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #fff;
  ::v-deep .van-loading__text {
    color: #fff !important;
  }
  ::v-deep .van-loading__circular {
    color: #fff;
  }
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #7e7e7e;
    margin-bottom: 20px;
    position: relative;
    // z-index: 100;
  }
}
.content {
  text-align: left;
  padding: 15px 10px;
  line-height: 24px;
  max-height: 120px;
  overflow-y: scroll;
}
.btn {
  margin: 20px 0;
}
.paymentSelect {
  padding: 20px;
  text-align: center;
  .van-radio {
    margin: 10px 0;
  }
}
.ticketSelect {
  text-align: center;
  .van-radio-group {
    display: inline-block;
  }
  .van-radio {
    margin: 10px 0;
  }
}
.refreshBox {
  max-height: 88vh;
  overflow-y: scroll;
  padding-bottom: 64px;
  box-sizing: border-box;
}
.refreshBox.reBox{
  max-height: 94vh;
}
.refreshBox.srb{
  padding-bottom: 40px;
  max-height: 94vh;
}
.refreshBox.rb{
  // max-height: 100vh;
  padding-bottom: 0px;
}
.refreshBox::-webkit-scrollbar {
  display: none;
}

.btnBoxPay {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 0 10px;
  height: 64px;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;
  position: fixed;
  bottom: 0px;
  left: 0px;
  > div {
    width: 60%;
    > span:nth-of-type(1) {
      font-size: 14px;
    }
    > span:nth-of-type(2) {
      color: #f7b500;
      font-size: 20px;
    }
  }
  .totalWord {

    font-size: 12px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
    display: flex;
    align-items: center;
    .word {
      margin-left: 8px;

      font-size: 12px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 400;
    }
    .mon {

      font-size: 14px;
      color: #f46c6c;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .btn {
    width: 100px;
    height: 40px;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;

    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    border: none;
    position: relative;
    .blueSha {
      width: 324px;
      height: 34px;
      position: absolute;
      left: 50%;
      top: 68%;
      transform: translateX(-50%);
    }
  }
}


.billDetails {
  > h2 {

    font-size: 24px;
    color: #464a4c;
    letter-spacing: 0;
    text-align: right;
    font-weight: 400;
    text-align: center;
    padding: 30px 0;
  }
  .billDetails_body {
    display: flex;
    justify-content: space-between;
    margin: 0 25px;
    margin-bottom: 30px;
    height: 100px;
    align-items: center;
    padding: 0 20px;
    background: rgba(48, 186, 129, 0.1);
    border-radius: 10px;
    h2 {

      font-size: 20px;
      // color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  //  linear-gradient(
  //     115deg,
  //     #2daf72 0%,
  //     #30bf83 42%,
  //     #37cf94 94%
  //   )
  .billDetails_body_active {
    background-image:linear-gradient(-45deg, #54adfb 0%, #297bf4 100%) !important;
  }
}
</style>
